/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import cn from 'classnames';

interface ToggleProps {
	checked?: boolean,
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
	disabled?: boolean;
	title?: string;
	className?: string;
	onLabel?: string;
	offLabel?: string;
	ariaLabel: string;
}

const Toggle = (props: ToggleProps) => {
	const {
		checked = false,
		onChange,
		disabled = false,
		title,
		className,
		onLabel = 'On',
		offLabel = 'Off',
		ariaLabel,
	} = props;

	const [isFocused, setIsFocused] = useState(false);

	return (
		<>
			<label
				className={cn('toggle', className)}
				title={title}
			>
				<input
					type="checkbox"
					checked={checked}
					onChange={onChange}
					disabled={disabled}
					data-testid="checkbox-toggle"
					onFocus={() => setIsFocused(true)}
					onBlur={() => setIsFocused(false)}
				/>
				<span className={cn('slider', { checked: checked }, isFocused && 'focused')} />
				<span className="labels" data-on={onLabel} data-off={offLabel} />
				<span className="invisible-label">
					{ariaLabel}
				</span>
			</label>
		</>
	);
};

export default Toggle;
